// extracted by mini-css-extract-plugin
module.exports = {"error":"Q_x"};